import { BASE_URL } from '@utils/constants.js';
import { logoutClearStore } from '@utils/functions.js';
import httpClient from '@utils/httpClient.js';
import Cookies from 'js-cookie';
import { call, put, takeLatest } from 'redux-saga/effects';

import { userSettingsError, userSettingsRequest, userSettingsStore, userSettingsStoreEntitlements } from './userSettingsActions.js';

function getUserSettingsApiCall() {
  return httpClient.get(`api/settings`);
}

function getEntitlementsApiCall(profileId) {
  return httpClient.get(`api/plan/entitlements${profileId ? `?profileId=${profileId}` : ''}`);
}

// Flatten { limits: { Key: { limit, isUnlimited, usage } } } → { limits: { Key: limit }, usage: { Key: usage } }.
function* loadEntitlementsSaga() {
  try {
    const profileId = localStorage.getItem('unilinkProfileId');
    const { data: ent } = yield call(getEntitlementsApiCall, profileId);
    const limits = {};
    const usage = {};
    Object.keys(ent?.limits || {}).forEach((key) => {
      limits[key] = ent.limits[key]?.limit;
      usage[key] = ent.limits[key]?.usage ?? 0;
    });
    yield put(userSettingsStoreEntitlements({ limits, usage }));
  } catch {
    // Non-fatal: meters just won't render until entitlements load.
  }
}

function logoutApiCall() {
  return httpClient.post(`api/account/logout`);
}

function* getUserSettingsSaga() {
  try {
    const { data: userSettings } = yield call(getUserSettingsApiCall);

    yield put(userSettingsStore(userSettings));

    Cookies.set('unilinkUserId', userSettings['userId'], { path: '/' });

    yield call(loadEntitlementsSaga);
  } catch (error) {
    if (error?.response?.status === 401) {
      yield call(logoutApiCall);
      logoutClearStore();
      window.open(BASE_URL, '_self');
    }
    // console.log('getUserSettingsSaga error', error.toString());
    // console.log('getUserSettingsSaga error', error);
    yield put(userSettingsError(error.Message ? error.Message : error.toString()));
  }
}

export function* getUserSettingsWatcher() {
  yield takeLatest(userSettingsRequest.type, getUserSettingsSaga);
}
